/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReassessmentWindow,
    ReassessmentWindowFromJSON,
    ReassessmentWindowFromJSONTyped,
    ReassessmentWindowToJSON,
    SurveyData,
    SurveyDataFromJSON,
    SurveyDataFromJSONTyped,
    SurveyDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface PatientData
 */
export interface PatientData {
    /**
     * 
     * @type {string}
     * @memberof PatientData
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PatientData
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PatientData
     */
    programStartedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientData
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PatientData
     */
    program: string;
    /**
     * Total number of sessions completed by the user.
     * @type {number}
     * @memberof PatientData
     */
    sessionsTotal: number;
    /**
     * Number of sessions completed by the user in the past week.
     * @type {number}
     * @memberof PatientData
     */
    sessionsPastWeek: number;
    /**
     * 
     * @type {Array<SurveyData>}
     * @memberof PatientData
     */
    surveys: Array<SurveyData>;
    /**
     * 
     * @type {Array<ReassessmentWindow>}
     * @memberof PatientData
     */
    reassessmentWindows: Array<ReassessmentWindow>;
}

export function PatientDataFromJSON(json: any): PatientData {
    return PatientDataFromJSONTyped(json, false);
}

export function PatientDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['first-name'],
        'lastName': json['last-name'],
        'programStartedAt': !exists(json, 'program-started-at') ? undefined : json['program-started-at'],
        'email': json['email'],
        'program': json['program'],
        'sessionsTotal': json['sessions-total'],
        'sessionsPastWeek': json['sessions-past-week'],
        'surveys': ((json['surveys'] as Array<any>).map(SurveyDataFromJSON)),
        'reassessmentWindows': ((json['reassessment-windows'] as Array<any>).map(ReassessmentWindowFromJSON)),
    };
}

export function PatientDataToJSON(value?: PatientData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first-name': value.firstName,
        'last-name': value.lastName,
        'program-started-at': value.programStartedAt,
        'email': value.email,
        'program': value.program,
        'sessions-total': value.sessionsTotal,
        'sessions-past-week': value.sessionsPastWeek,
        'surveys': ((value.surveys as Array<any>).map(SurveyDataToJSON)),
        'reassessment-windows': ((value.reassessmentWindows as Array<any>).map(ReassessmentWindowToJSON)),
    };
}


